import React from "react"
import {CustomRetrieveWrapper} from './style.jsx'
import {isApplyCustomLayout} from '../const.js'
const CustomRetrieve = ({children}) => {
  return <CustomRetrieveWrapper isApplyCustomLayout={isApplyCustomLayout}>{children}</CustomRetrieveWrapper>
}
export default CustomRetrieve



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomRetrieve/index.js